<nav class="navbar navbar-expand-lg bg-dark bg-aeromexico">
    <a class="navbar-brand">
        <img src="../../../../assets/am-servicios-logo-navbar.png" class="d-inline-block align-top navbar-logo">
    </a>
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent">
        <i class="fa-solid fa-bars"></i>
    </button>
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav me-auto mb-2 mb-lg-0">
            @if(!isReportsRole()){
                <li class="nav-item">
                    <a class="nav-link" routerLink="cargas" routerLinkActive="router-link-active">Cargas</a>
                </li>
            }
           
            <li class="nav-item">
                <a class="nav-link" routerLink="reportes" routerLinkActive="router-link-active">Reportes</a>
            </li>
            @if (!isReportsRole()) {
                <li class="nav-item">
                    <a class="nav-link" routerLink="usuarios">Usuarios</a>
                </li>

                <li class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                        Catálogos
                    </a>
                    <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                        <li><a class="dropdown-item" routerLink="activos">Activos</a></li>
                        <li><a class="dropdown-item" routerLink="almacenes">Almacenes</a></li>
                        <li><a class="dropdown-item" routerLink="combustibles">Combustibles</a></li>
                        <li><a class="dropdown-item" routerLink="compania">Compañias</a></li>
                        <li><a class="dropdown-item" routerLink="estaciones">Estaciones</a></li>
                        <li><a class="dropdown-item" routerLink="familias">Familias</a></li>
                    </ul>
                </li>
            }
        </ul>
        <ul class="navbar-nav navbar-spacer">
                <li class="name-section"><span>{{ currentName }}</span>
                </li>
            <li>
                <button type="button" (click)="logout()" class="logout-button">
                    Cerrar sesión
                </button>

            </li>
        </ul>
    </div>
</nav>